import { getLink } from "../../../utils/utils";

const content = {
  esp: (
    `
    <p class="mb-3 italic text-center">(laŭ la melodio de «Nadeĵda»)</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Suno nun ridetas de ĉiel’, <br/>
        Primavero venas kun rideto. <br/>
        Estas klara nobla nia cel’: <br/>
        Vin gajigi bone dum koncerto. <br/>
        Vi pro tio venis al Odes’, <br/>
        Kaj Odeso kiel la patrino <br/>
        Kore vin renkontas kun kares’, <br/>
        Ĉiam juna urbo-belulino.
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Odeso – la amo, la ĝoj’, <br/>
        Kaj esperon ni firme konservu, <br/>
        Ke estu ne lasta la foj’ <br/>
        Ke lok’ por kunveno ĝi servu.
      </p>

      <p class="poem-block mb-3">
        Nur du tagojn estis kune ni, <br/>
        Sed por la monatoj jam sufiĉos <br/>
        Rememoroj pri la kompani’, <br/>
        Pri la tagoj, plenaj de feliĉo. <br/>
        Ie ni kunvenos dum somer’, <br/>
        Nova loko vokas intereson, <br/>
        Sed ni ne forgesu pri esper’ <br/>
        Iam plu reveni en Odeson!
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>

    </div>
    `
  )
}

const itemName = {
  esp: 'Himno de Odesa humurfesto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['MNy65TItXnU'],
    itemTranslator: `
      Muziko: Aleksandra Paĥmutova, <br/>
      Teksto: T. Auderskaja
    `
  }
}

export default item;